import React, {useCallback} from 'react'
import {TREE_LEADERBOARD_LOAD_LIMIT} from 'consts'
import {requestData} from 'services'
import {TreeLeaderboardData} from 'types'
import {ListLazy} from 'common/components'
import convertUnit from 'lib/unit'
import FototreeTallestTreeListItem from './FototreeTallestTreeListItem'
import {FototreeTallestTreeListProps} from './FototreeTallestTreeProps'

export default function FototreeTallestTreeList({
  type,
  onClickItem,
}: FototreeTallestTreeListProps) {
  const handleLoadData = useCallback(
    async (
      page: number,
      limit: number,
    ): Promise<TreeLeaderboardData[] | null> => {
      const response = await requestData(
        type === 'ALL'
          ? 'tree_get_fototree_leaderboard'
          : 'forkygram_get_fototree_leaderboard',
        {
          useDefaultMessage: true,
          params: {
            page,
            limit,
            filter_type: type === 'ALL' ? undefined : type,
          },
        },
      )

      return typeof response !== 'string' && response?.status === 200
        ? response.data.result.map((item) => ({
            ...item,
            type,
          }))
        : null
    },
    [type],
  )

  const handleRenderListItem = useCallback(
    (item: TreeLeaderboardData, index) => (
      <FototreeTallestTreeListItem
        data={item}
        rank={index + 1}
        onClickItem={onClickItem}
      />
    ),
    [onClickItem],
  )

  return (
    <ListLazy
      keyExtractor={(item) => (item.type === 'ALL' ? item.id : item.tree_id)}
      loadData={handleLoadData}
      renderItem={handleRenderListItem}
      limitPerPage={TREE_LEADERBOARD_LOAD_LIMIT}
      scrollbar={false}
      contentContainerStyle={{
        padding: `${convertUnit(12)} ${convertUnit(16)}`,
      }}
    />
  )
}
